@let context = layoutContextService.context$ | async;

@if (highchartsStore.chartOptions(); as chartOptions) {
  @if (highchartsStore.showChart()) {
    @let chartType = chartOptions.chart?.type;
    @let isLegacyChart = chartType === 'gantt' || chartType === 'bubble';
    <div
      class="bd-highcharts-container"
      [attr.data-id]="highchartsStore.configuration()?.visualizationId ?? ''"
      [ngClass]="{
        'bd-visualization-container': isLegacyChart,
        'bd-highcharts-preview-container': previewMode,
      }"
    >
      <highcharts-chart
        data-id="bd-highcharts-visualization"
        [constructorType]="chartType === 'gantt' ? 'ganttChart' : 'chart'"
        [options]="chartOptions"
        class="bd-highcharts"
        [ngClass]="{
          'bd-highcharts-overlay-width': context === 'overlay' && !previewMode,
          'bd-highcharts-primary-width': context === 'primary' && !previewMode,
          'bd-highcharts-preview': previewMode,
        }"
        (chartInstance)="onChartInstance($event)"
      ></highcharts-chart>
    </div>
    @if (!previewMode && !isOverlayOutlet) {
      <bd-highcharts-drawers-container
        (contentDetailsClose)="onContentDetailsClose()"
        (contentRefresh)="onContentRefresh()"
        (contentItemAddTo)="onContentItemAddTo($event)"
      ></bd-highcharts-drawers-container>
    }
    @if (highchartsStore.showLoader() && !previewMode) {
      <bd-loader data-id="highcharts-loader"></bd-loader>
    }
  }
} @else {
  @if (context === 'overlay') {
    <div
      class="h-full w-full flex justify-center align-center flex-col gap-[50px] bd-loader-container bg-white"
    >
      <bd-loader
        [styleClass]="'!relative'"
        data-id="frame-container-loader"
      ></bd-loader>
      <bd-call-to-action
        tScope="featureAiAssistant"
        titleKey="loadingScreen.title"
        subtitleKey="loadingScreen.description"
      ></bd-call-to-action>
    </div>
  } @else if (!previewMode) {
    <bd-loader data-id="highcharts-loader"></bd-loader>
  }
}
